import request from '@/utils/request'

//获取教学实验课列表
export function getmyarrangedlist(params) {
  return request({
    url: '/portal/course-lib-timetable/get-my-arranged-list',
    method: 'GET',
    params
  })
}

//获取录像时段列表
export function cameraPeriodList(params) {
  return request({
    url: '/portal/camera-period/get-list',
    method: 'GET',
    params
  })
}

//获取录像列表
export function cameraVideoGetList(params) {
  return request({
    url: '/portal/camera-video/get-list',
    method: 'GET',
    params
  })
}